import Whyi3 from './Whyi3'

export default Whyi3
